(function () {
  function createHiddenInput(drop, name, value) {
    let hidden = drop.querySelector('input[type="hidden"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = name;
      drop.appendChild(hidden);
    }
    hidden.value = value;
    return hidden;
  }

  function openFloating(drop) {
    if (drop._floating) return;
    const selected = drop.querySelector('.selected');
    const options = drop.querySelector('.options');

    // create floating element before using it
    const floating = document.createElement('div');
    floating.className = 'floating-options';

    // copy only the option nodes into the floating container
    Array.from(options.querySelectorAll('.option')).forEach(opt => {
      const clone = document.createElement('div');
      clone.className = 'option';
      clone.dataset.value = opt.dataset.value;
      clone.innerHTML = opt.innerHTML;
      floating.appendChild(clone);
    });

    // append floating to the dropdown (so absolute positioning is relative to .color-dropdown)
    drop.appendChild(floating);

    // compute sizes based on selected element (use offsetWidth to match layout and CSS min-width)
    const spacing = 10; // vertical spacing in px
    const selWidth = selected.offsetWidth;
    const selHeight = selected.offsetHeight;
    const appliedWidth = Math.max(selWidth, 140);

    floating.style.position = 'absolute';
    floating.style.left = '0';
    floating.style.top = (selHeight + spacing) + 'px';
    floating.style.width = appliedWidth + 'px';

    // attach click handlers to cloned options
    Array.from(floating.querySelectorAll('.option')).forEach(opt => {
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        const value = this.dataset.value;
        selected.innerHTML = this.innerHTML;
        createHiddenInput(drop, drop.dataset.name, value);
        closeFloating(drop);
      });
    });

    drop._floating = floating;
    drop.classList.add('open');

    // outside click handler (capture)
    drop._outsideHandler = function (e) {
      if (!drop.contains(e.target) && !(floating && floating.contains(e.target))) {
        closeFloating(drop);
      }
    };
    document.addEventListener('click', drop._outsideHandler, true);

    // reposition on resize/scroll (keep absolute relative to drop)
    drop._reposition = function () {
      const sel = drop.querySelector('.selected');
      if (!sel || !drop._floating) return;
      const spacing2 = 10;
      const selW = sel.offsetWidth;
      const selH = sel.offsetHeight;
      const appliedW2 = Math.max(selW, 140);
      drop._floating.style.top = (selH + spacing2) + 'px';
      drop._floating.style.width = appliedW2 + 'px';
      drop._floating.style.left = '0';
    };
    window.addEventListener('resize', drop._reposition);
    window.addEventListener('scroll', drop._reposition, true);
  }

  function closeFloating(drop) {
    if (!drop._floating) return;
    if (drop._floating.parentNode) drop._floating.parentNode.removeChild(drop._floating);
    drop._floating = null;
    drop.classList.remove('open');
    if (drop._outsideHandler) {
      document.removeEventListener('click', drop._outsideHandler, true);
      drop._outsideHandler = null;
    }
    if (drop._reposition) {
      window.removeEventListener('resize', drop._reposition);
      window.removeEventListener('scroll', drop._reposition, true);
      drop._reposition = null;
    }
  }

  function initDropdown(drop) {
    const selected = drop.querySelector('.selected');
    const options = drop.querySelector('.options');
    const firstOpt = options.querySelector('.option');
    if (firstOpt) {
      selected.innerHTML = firstOpt.innerHTML;
      createHiddenInput(drop, drop.dataset.name, firstOpt.dataset.value);
    }

    selected.addEventListener('click', function (e) {
      e.stopPropagation();
      if (drop._floating) closeFloating(drop);
      else openFloating(drop);
    });

    selected.setAttribute('tabindex', '0');
    selected.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (drop._floating) closeFloating(drop);
        else openFloating(drop);
      } else if (e.key === 'Escape') {
        closeFloating(drop);
      }
    });
  }

  document.querySelectorAll('.color-dropdown').forEach(initDropdown);

})();